<template>
  <div class="container">
    <span class="data">数据概览</span>
    <div class="cardAll">
      <el-card class="cardOne">
          <div>
            <img class="img" src="../../static/img/equTotal.png"/>
            <span class="all">{{ onlineRate }}%</span>
            <span class="equAll">设备在线率</span>
          </div>
      </el-card>
      <el-card class="cardTwo">
        <div>
          <img class="img" src="../../static/img/zaiXian.png"/>
          <span class="all">{{online}}</span>
          <span class="equAll">设备在线数</span>
        </div>
      </el-card>
      <el-card class="cardThree">
        <div>
          <img class="img" src="../../static/img/liXian.png"/>
          <span class="all">{{ offline }}</span>
          <span class="equAll">设备离线数</span>
        </div>
      </el-card>
      <el-col :span="12" style="position: fixed;top: 51%;left:16%;width: 600px">
        <el-card>
          <div style="height: 280px;width: 580px;" id="bing"></div>
        </el-card>
      </el-col>
      <el-col :span="12" style="position: fixed;top: 51%;left: 58%;width: 600px">
        <el-card>
          <div style="height: 280px;width: 540px" id="line"></div>
        </el-card>
      </el-col>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import axios from "axios";

export default {
  name: "UserNewHome",
  data(){
    return{
      option:{
        title: {
          text: '设备状态',
          subtext: 'Equ Status',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: '50%',
            data: [
              { value: 0, name: '在线设备率' },
              { value: 0, name: '离线设备率' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      option1: {
        title: {
          text: '全局耗电'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['设备改前耗电总和', '设备改后耗电总和', '共累计节省电量']
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [] // 初始为空，动态从接口获取数据
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '设备改前耗电总和',
            type: 'line',
            //stack: 'Total',
            itemStyle:{
              color: '#EE6666'
            },
            areaStyle: {
              color: 'rgba(238, 102, 102, 0.8)'
            },
            lineStyle: {
              color: '#EE6666'
            },
            emphasis: {
              focus: 'series'
            },
            data: [] // 初始为空，动态从接口获取数据
          },
          {
            name: '设备改后耗电总和',
            type: 'line',
            //stack: 'Total',
            itemStyle:{
              color: '#73C0DE'
            },
            areaStyle: {
             color: 'rgba(115, 192, 222,0.6)'
            },
            lineStyle: {
              color: '#73C0DE'
            },
            emphasis: {
              focus: 'series'
            },
            data: []// 初始为空，动态从接口获取数据
          },
          {
            name: '共累计节省电量',
            type: 'line',
            //stack: 'Total',
            // itemStyle:{
            //   color: '#73C0DE'
            // },
            // areaStyle: {
            //   color: 'rgba(115, 192, 222,0.6)'
            // },
            // lineStyle: {
            //   color: '#73C0DE'
            // },
             // areaStyle: {color: 'rgba(1, 122,21,0.8)'},
            emphasis: {
              focus: 'series'
            },
            data: []// 初始为空，动态从接口获取数据
          }
        ]
      },
      onlineRate:'',
      online:'',
      offline:'',
      company_id:''
    }
  },
  methods:{
    //给全局耗电赋值
    globalPowerConsumption(){
      //从缓存中取出来
      var userStr = localStorage.getItem('user');
      //检查是否有值
      if (userStr){
        // 将JSON字符串转换回JavaScript对象
        var user = JSON.parse(userStr);
        //获取com_id的值赋值给com_id
        var company_id = user.com_id
        console.log("2025-2-25 ---->",company_id)
        axios.get("otherApi/get_es_message",{
          params:{
            company_id:company_id
          }
        }).then(res => {
          console.log("2025-2-25data",res)
          // 处理数据并赋值给option1
          const data = res.data.data;
          console.log("接口返回的数据：", data);
          // 提取时间作为x轴数据
          const xAxisData = data.map(item => item.time).reverse();//reverse 反转数据
          // 提取Total_Pre_E, Total_After_E, Total_E_ImpEp作为series数据
          const preModPowerCon = data.map(item => parseFloat(item.Total_Pre_E));
          const postModPowerCon = data.map(item => parseFloat(item.Total_After_E));
          const postPre = data.map(item => parseFloat(item.Total_E_ImpEp));
          // 更新option1
          this.option1.xAxis[0].data = xAxisData;
          this.option1.series[0].data = preModPowerCon;
          // this.option1.series[1].data = postModPowerCon;
          this.option1.series[2].data = postPre;
          // 如果需要重新渲染图表，可以调用相应的方法
          var chartDom1 = document.getElementById('line');
          var myChart1 = echarts.init(chartDom1);
          myChart1.setOption(this.option1);
        })
      }
    },
    //给上面三个赋值
    getCompangDevices(){
      //从缓存中取出来
      var userStr = localStorage.getItem('user');
      //检查是否有值
      if (userStr){
        // 将JSON字符串转换回JavaScript对象
        var user = JSON.parse(userStr);
        //获取com_id的值赋值给com_id
        var company_id = user.com_id
      console.log("2024-9-3 ---->",company_id)
      axios.get("otherApi/get_compang_devices/",{
        params:{
          company_id:company_id
        }
      }).then(res =>{
        console.log(res)
        this.online = res.data.data.online;
        this.offline = res.data.data.offline;

        // 计算在线率
        let onlineRate = (this.online / (this.online + this.offline) * 100).toFixed(2);
        // 更新图表数据
        this.onlineRate = onlineRate
        // 更新饼图数据
        let pieData = [
          { value: this.online, name: '在线设备数' },
          { value: this.offline, name: '离线设备数' },
        ];
        // 更新 ECharts 饼图实例的 option
        let myChart = echarts.init(document.getElementById('bing'));  // 假设你的饼图 DOM ID 是 'yourPieChartDomId'
        myChart.setOption({
          series: [{
            data: pieData
          }]
        });
      }).catch(error =>{
        console.error('Equ New Home Error fetching data:', error);
      })
    }else {
        // 如果没有找到'user'键，则输出提示信息
        this.$message.error('没有找到用户数据');
      }
    },
    //给圆形图赋值
    //给折线图赋值
    getLine(){
      //从缓存中取出来
      var userStr = localStorage.getItem('user');
      //检查是否有值
      if (userStr) {
        // 将JSON字符串转换回JavaScript对象
        var user = JSON.parse(userStr);
        //获取com_id的值赋值给com_id
        var company_id = user.com_id
        console.log("2024-9-3 ---->", company_id)
        axios.get("otherApi/manager/getallcompanysensor/", {
          params: {
            company_id: company_id
          }
        }).then(res => {
          console.log("12-31", res)
          this.post_mod_power_con = res.data.data[0].post_mod_power_con;
          this.pre_mod_power_con = res.data.data[0].pre_mod_power_con;
          this.post_pre = res.data.data[0].pre_mod_power_con-res.data.data[0].post_mod_power_con;
        })
      }else {
        // 如果没有找到'user'键，则输出提示信息
        this.$message.error('没有找到用户数据');
      }
    }
  },
  mounted() {
    this.globalPowerConsumption();
    this.intervalId = setInterval(() => {
      this.globalPowerConsumption();
    }, 10000);

    this.getCompangDevices();
    this.getLine();
    var chartDom = document.getElementById('bing');
    var myChart = echarts.init(chartDom);
    myChart.setOption(this.option);

    var chartDom1 = document.getElementById('line');
    var myChart1 = echarts.init(chartDom1);
    myChart1.setOption(this.option1);
  },

  beforeDestroy() {
    // 在组件销毁前清除定时器，避免内存泄漏
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}

</script>

<style scoped>
.data{
  color: #66b1ff;
  font-size: 23px;
  font-weight: bold;
  position: fixed;
  top:115px;
  left:15%;
}

.cardOne, .cardTwo, .cardThree {
  position: fixed;
  top: 25%;
  width: 320px;
  height: 120px;
}

.cardOne { left: 20%; }
.cardTwo { left: 46%; }
.cardThree { left: 72%; }

.img{
  position: relative;
  top: 10px;
  left: -20px;
}
.all{
  position: relative;
  top: 10px;
  left: 45px;
}
.equAll{
  position: relative;
  top: -20px;
  left: -5px;
}
.container{
  height: 100%;
  width: 100%;

}
</style>



// WEBPACK FOOTER //
// src/components/UserNewHome.vue